import { type ExperimentFlags, stringValueFlags } from './constants';
import { getSearchParam } from './utils';

/**
 * Функция проверяет, задан ли URL-оверрайд флага для определённой функциональности
 *
 * Со стороны пользователя это выглядит, как GET-параметр в url — '/path?flags=flag1=value1;flag2=value2'
 *
 * @example getLocalExperimentalFlag({ name: 'enable_checkout_editor', value: 'exp' }) => boolean
 * @example getLocalExperimentalFlag({ name: 'alty_queue' }) => string | null
 */
export function getLocalExperimentalFlag<K extends keyof ExperimentFlags>({
    name,
    value,
}: {
    name: K;
    value: ExperimentFlags[K];
}): boolean;

export function getLocalExperimentalFlag<K extends (typeof stringValueFlags)[number]>({
    name,
}: {
    name: K;
}): string | null;

export function getLocalExperimentalFlag<K extends keyof ExperimentFlags>({
    name,
    value,
}: {
    name: K;
    value?: ExperimentFlags[K];
}): boolean | string | null {
    const flagParam = getSearchParam();

    if (!flagParam) {
        return stringValueFlags.includes(name) ? null : false;
    }

    const splittedFlags = flagParam.split(';');

    for (let i = 0; i < splittedFlags.length; i++) {
        const [flagName, flagValue] = (splittedFlags[i] || '').split('=');

        if (flagName === name) {
            // Для строковых флагов возвращаем значение
            if (stringValueFlags.includes(name)) {
                return flagValue || null;
            }

            // Для булевых флагов проверяем соответствие значения
            if (value !== undefined && flagValue === String(value)) {
                return true;
            }
        }
    }

    return stringValueFlags.includes(name) ? null : false;
}
